import { EBooleanSearchActionsTypes } from "@similarweb/ui-components";

import { proNavigator } from "single-spa/react-app/ProNavigator";

import { BooleanSearchWithBothKeywordsAndWebsite } from "./BooleanSearchWithBothKeywordsAndWebsite";

const DEFAULT_API_SEPARATOR = ",";
const filterByAction = (action) => (items) =>
    items
        .filter((item) => item.action === action)
        .map((item) => item.text)
        .join(DEFAULT_API_SEPARATOR);
export const getInitialItemArray = (action) => (item) =>
    item ? item.split(DEFAULT_API_SEPARATOR).map((text) => ({ text, action, id: Math.random() })) : [];

export const BooleanSearchWithBothKeywordsAndWebsiteWrapper = (props) => {
    const onChange = (items) => {
        const excludeTerms = filterByAction(EBooleanSearchActionsTypes.excludeKeyword)(items);
        const excludeUrls = filterByAction(EBooleanSearchActionsTypes.excludeUrl)(items);
        const includeTerms = filterByAction(EBooleanSearchActionsTypes.includeKeyword)(items);
        const includeUrls = filterByAction(EBooleanSearchActionsTypes.includeUrl)(items);
        const booleanSearchParams = {
            ExcludeTerms: excludeTerms,
            ExcludeUrls: excludeUrls,
            IncludeTerms: includeTerms,
            IncludeUrls: includeUrls,
        };

        proNavigator.applyUpdateParams(booleanSearchParams);
        // calling props.onApplyChanges in order to enable the parent component to act after the url has been changed
        // (relevant when the state is with reloadOnSearch=false)
        props?.onApplyChanges?.(booleanSearchParams);
    };

    const getInitialItems = () => {
        // if we don't get filters in props we take it from the URL params
        const {
            ExcludeTerms: excludeTerms,
            ExcludeUrls: excludeUrls,
            IncludeTerms: includeTerms,
            IncludeUrls: includeUrls,
        } = props.filters ? props.filters : proNavigator.getParams();
        const excludeTermsArray = getInitialItemArray(EBooleanSearchActionsTypes.excludeKeyword)(excludeTerms);
        const excludeUrlsArray = getInitialItemArray(EBooleanSearchActionsTypes.excludeUrl)(excludeUrls);
        const includeTermsArray = getInitialItemArray(EBooleanSearchActionsTypes.includeKeyword)(includeTerms);
        const includeUrlsArray = getInitialItemArray(EBooleanSearchActionsTypes.includeUrl)(includeUrls);
        const logicalSeparator = {
            text: "AND",
            action: "logicalSeparator",
            id: "logicalSeparator",
        };
        return [
            ...includeTermsArray,
            includeTermsArray.length > 0 && excludeTermsArray.length > 0 && logicalSeparator,
            ...excludeTermsArray,
            ...includeUrlsArray,
            includeUrlsArray.length > 0 && excludeUrlsArray.length > 0 && logicalSeparator,
            ...excludeUrlsArray,
        ];
    };

    return (
        <BooleanSearchWithBothKeywordsAndWebsite
            onChange={onChange}
            chips={getInitialItems()}
            {...props}
        />
    );
};
